import { createSlice } from '@reduxjs/toolkit';

export const defaultLoadingState = {
    loading: false,
    actions: {
        login: false,
        logout: false,
        update: false,
        register: false,
        forgotPassword: false,
        getPlayerData: false,
        clearErrors: false,
        getConfig: false,
        getGames: false,
        getDrawings: false,
        postFeedback: false,
        getEntries: false,
        getBanners: false,
        getPromotions: false,
        getPromotionsDetail: false,
        enterDrawTicket: false,
        setGameOver: false,
    },
};

// REDUCERS

const setLoadingReducer = (state, action = { payload: {} }) => {
    const { payload } = action;

    if (payload && payload['action']) {
        var loadingActions = {};

        loadingActions[payload.action] = true;

        return {
            ...state,
            actions: {
                ...state.actions,
                ...loadingActions,
            },
        };
    }
    return {
        ...state,
    };
};

const unsetLoadingReducer = (state, action = { payload: {} }) => {
    const { payload } = action;

    if (payload && payload['action']) {
        var loadingActions = {};

        loadingActions[payload.action] = false;

        return {
            ...state,
            actions: {
                ...state.actions,
                ...loadingActions,
            },
        };
    }
    return {
        ...state,
    };
};

export const loadingSlice = createSlice({
    name: 'loading',
    initialState: defaultLoadingState,
    reducers: {
        // add an action to chceck localstorage
        // for existing session
        setLoading: setLoadingReducer,
        unsetLoading: unsetLoadingReducer,
    },
});

// ACTUAL ACTIONS
// a place to make the actions more complex if necessary

const setLoading = (dispatch, payload) => {
    if (!loadingSlice.loading) {
        const result = dispatch(loadingSlice.actions.setLoading(payload));
        return result;
    }
};

const unsetLoading = (dispatch, payload) => {
    if (loadingSlice.loading) {
        const result = dispatch(loadingSlice.actions.unsetLoading(payload));
        return result;
    }
};

export const loadingActions = (dispatch) => {
    return {
        // dispatching plain actions
        setLoading: (payload) => setLoading(dispatch, payload),
        unsetLoading: (payload) => unsetLoading(dispatch, payload),
    };
};
